module.exports = __webpack_public_path__ + "images/imagebetter1.cedd68a9.png";